import React from "react";
import { sanitizeHTML } from "../../../search/utils";
import { testimonialType } from "../../types/product";
import { ConditionalWrapper } from "../../components/ConditionalWrapper";

export function Testimonial({ item }: { item: testimonialType }) {
	const { companyLogo, sourceName, sourcePositionAndCompany, quote } = item;
	const { altText, link, url } = companyLogo || {};

	return (
		<article className="quote-card typography--big">
			<div
				dangerouslySetInnerHTML={{
					__html: sanitizeHTML(quote.rawHtml),
				}}
			/>
			<div className="card-company">
				<p>
					<strong>{sourceName}</strong>
					{sourcePositionAndCompany}
				</p>
				<ConditionalWrapper
					condition={!!link}
					wrapper={(children) => (
						<a
							href={link}
							target="_blank"
							rel="noopener noreferrer"
						>
							{children}
						</a>
					)}
				>
					{companyLogo && <img src={url} alt={altText} />}
				</ConditionalWrapper>
			</div>
		</article>
	);
}
